<template>
    <span
        class="rounded-full font-semibold"
        :class="[
            meta.class,
            large ? 'px-3 py-1 text-sm' : 'px-2 py-0.5 text-xs'
        ]"
    >
        {{ meta.label }}
    </span>
</template>

<script>
import { subscriptionStatusesMeta } from "@/common/fields/platform-subscription-codes";

export default {
    name: "SubscriptionStatusBadge",
    props: {
        status: {
            type: String,
            required: true
        },
        large: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        meta() {
            return (
                subscriptionStatusesMeta[this.status] || {
                    label: this.status,
                    class: "bg-theme-muted text-theme-inverse"
                }
            );
        }
    }
};
</script>
